export const baseURL = 'https://api.dscj2016.com'
// export const baseURL = 'http://120.76.142.7/express/web'
// export const baseURL = 'http://192.168.137.25:8080/166/web'


// WEBPACK FOOTER //
// ./src/utils/url.js